export default __webpack_public_path__ + "static/media/SOS.c00bd39f.jpg";